import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import './App.css';
import '@fontsource/roboto';
import ErrorBoundary from './Components/ErrorBoundary';
const SignIn = lazy(() => import('./Screens/Auth/sign-in'));
const NameInfo = lazy(() => import('./Screens/Auth/name'));
const Personalize = lazy(() => import('./Screens/Auth/personalize'));
const SMSConfirmation = lazy(() => import('./Screens/Auth/confirmation'));
const ErrorScreen = lazy(() => import('./Components/ErrorScreen')); // Import your custom error page
const RedirectHandler = lazy(() => import("./Components/RedirectHandler"));
const TermsAndConditions = lazy(() => import('./Screens/terms'));
const UpdateProfile = lazy(() => import('./Screens/Auth/update-profile'));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/login" replace />, // Redirect to login
  },
  {
    path: "/login",
    element: <SignIn />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/redirect",
    element: <RedirectHandler />,
    errorElement: <ErrorScreen />
  },
  {
    path: "/name",
    element: <NameInfo />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/register",
    element: <Personalize />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/sms-confirmation",
    element: <SMSConfirmation />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/terms",
    element: <TermsAndConditions />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/update-profile",
    element: <UpdateProfile />,
    errorElement: <ErrorScreen />, // Add custom error element
  }
]);

function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<div>Loading...</div>}>
        <RouterProvider router={router} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
